import {API_BASE_URL} from './api';
export const ENDPOINTS = {
  USERS: {
    LOGIN: `${API_BASE_URL}users/login`,
    EMAIL_VERIFY: `${API_BASE_URL}users/email/verify`,
    REGISTER: `${API_BASE_URL}users/`,
    UPDATE: `${API_BASE_URL}users/`,
    PROFILE: `${API_BASE_URL}users/profile`,
    FORGOT_PASSWORD: `${API_BASE_URL}users/forgot/password/email`,
    LOGOUT: `${API_BASE_URL}users/logout`,
    DELETE: (id: string) => `${API_BASE_URL}users/${id}`,
    DELETE_PAYMENT: (id: string) => `${API_BASE_URL}users/delete/payment/method/${id}`,
    SET_DEFAULT_PAYMENT_METHOD: `${API_BASE_URL}users/set/payment/method/default`,
    GET_PAYMENT_METHOD: `${API_BASE_URL}users/get/payment/method`,
    ADD_PAYMENT_METHOD: `${API_BASE_URL}users/create/payment/method`,
    CHANGE_PASSWORD: `${API_BASE_URL}users/password/change`,
    RESET_PASSWORD: `${API_BASE_URL}users/password/reset`,
    ONBOARDING: `${API_BASE_URL}users/stripe/onboarding`,
    EXTERNAL_ACCOUNT_LIST: `${API_BASE_URL}users/externalAccountList`,
    ADD_BANK_CARD: `${API_BASE_URL}users/stripe/external/account/details`,
        ADD_BANK_CARD2: `${API_BASE_URL}users/stripe/external/account/details/v1`,
    SET_DEFAULT_BANK_ACCOUNT: `${API_BASE_URL}users/setDefaultSubaccount`,
    DELETE_BANK_ACCOUNT: (id: string) => `${API_BASE_URL}users/deleteSubaccount/${id}`,
    BALANCE: `${API_BASE_URL}users/balance`,
    PAYOUT: `${API_BASE_URL}users/payout/details`,
    INSTANT_PAYOUT_CARD: `${API_BASE_URL}users/instant-payout-card`,
    EDIT_PAYOUT: `${API_BASE_URL}users/edit-Payout`,
    MANUAL_PAYOUT: `${API_BASE_URL}users/manual-payout`,
    INTENT_TOKEN: `${API_BASE_URL}users/payment/intent/token`,
    ADD_CARD_TOKEN: `${API_BASE_URL}users/stripe/external/account/details`,
        REFRESH: `${API_BASE_URL}users/token/refresh`,

  },

  OTP: {
    CREATE: `${API_BASE_URL}otp/create`,
    VERIFY: `${API_BASE_URL}otp/verify`,
  },
  STRIPE : {
    REAUTH:       (userId: string) => `${API_BASE_URL}stripe/webhooks/reauth?userId=${userId}`,
    RETURN:       (userId: string, json = false) => `${API_BASE_URL}stripe/webhooks/return?userId=${userId}` + (json ? '&json=true' : ''),
    ONBOARD_HOOK: `${API_BASE_URL}stripe/webhooks/onboard`
  },

  PROPERTIES: {
    BASE: `${API_BASE_URL}properties`,
    BUY: `${API_BASE_URL}properties/buy`,
    GENERATE_BID: `${API_BASE_URL}properties/generate-bid`,
    SUBMIT_BID: `${API_BASE_URL}properties/submit-bid`,
    BID_LIST: `${API_BASE_URL}properties/bids`,
    ACCEPT_BID: `${API_BASE_URL}properties/accept-bid`,
    REJECT_BID: `${API_BASE_URL}properties/reject-bid`,
    PRICE_HISTORY: (buildingId: string) =>
      `${API_BASE_URL}properties/price-history?buildingId=${encodeURIComponent(buildingId)}`,
        CANCEL_BID: `${API_BASE_URL}properties/cancel-bid`,
    CANCEL_SALE: `${API_BASE_URL}properties/`,
    LEADERBOARD: `${API_BASE_URL}properties/leading-board`,
  },
  

  BUILDINGS: `${API_BASE_URL}buildings`,
  ACTIVITIES: `${API_BASE_URL}activities`,
  WEBVIEW: `${API_BASE_URL}webview`,
};
